import React, { Component } from 'react';
import HeaderLink from './HeaderLink';

export default class HeaderDropdown extends Component {
    // TODO 10/26/20 removing header dropdown in favor of donate link
    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         showDropdown: false
    //     };
    // }

    // showDropdown() {
    //     this.setState({ showDropdown: true });
    // }

    // hideDropdown() {
    //     this.setState({ showDropdown: false });
    // }

    render() {
        return (
            <div className="HeaderDropdown">
                <HeaderLink
                    to="https://youthcampsforchrist.campintouch.com/ui/forms/donor/Form"
                    label="Donate"
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Header/HeaderDropdown.js